import { gql } from '@apollo/client';

export const fittingsFragment = gql`
  fragment FittingFields on Fitting {
    id
    tag
    tradeSize
    bendRadius
    updatedTime
    updatedBy
    racewayCodeFittings {
      id
      racewayCodeId
      fittingId
      updatedTime
      updatedBy
    }
  }
`;

export const SEARCH_FITTINGS = gql`
  ${fittingsFragment}
  query searchFittings($searchInput: SearchInput) {
    searchFittings(searchInput: $searchInput) {
      items {
        ...FittingFields
      }
    }
  }
`;

export const SAVE_FITTINGS = gql`
  ${fittingsFragment}
  mutation SaveFittings($saveFittingInput: SaveFittingInput!) {
    saveFittings(saveFittingInput: $saveFittingInput) {
      fittings {
        ...FittingFields
      }
      deletedIds
      errors {
        tag
        messageKeys
      }
    }
  }
`;
